import styled from 'styled-components'

export const DataRow = styled.div`
	display: flex;
	align-items: center;
	padding: 12px 10px;
	&:nth-child(odd) {
		background: rgba(195, 195, 195, 0.2);
	}
	&:nth-child(even) {
		background: #fff;
	}
	& > span {
		overflow: hidden;
		text-overflow: ellipsis;
		&:first-child {
			flex-basis: 63%;
			max-width: calc(63% - 12px);
		}
		&:nth-child(2) {
			flex-basis: 45%;
			margin-left: -5px;
		}
	}
`

export const DataWrapper = styled.div`
	display: flex;
	&:nth-child(odd) {
		${DataRow} { background: rgba(195, 195, 195, 0.2); }
	}
	&:nth-child(even) {
		${DataRow} { background: #fff; }
	}
	& > div {
		flex-basis: 50%;
		max-width: calc(50% - 5px);
		&:nth-child(even) {
			margin-left: 10px;
		}
	}
`
